import { jsx as s } from "@emotion/react/jsx-runtime";
const a = ({
  alt: m,
  src: o,
  width: r,
  height: t,
  title: e,
  className: g,
  style: i,
  onError: p
}) => /* @__PURE__ */ s("img", { alt: m, src: o, width: r, height: t, title: e, className: g, style: i, onError: p });
export {
  a as Image
};
